import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { betTypeMap } from 'src/types/domain/BetDetails'

type Props = Readonly<{
  betType: keyof typeof betTypeMap
  className?: string
}>

export function BetTypeLabel({ betType, className }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const BetLabelMap: Record<keyof typeof betTypeMap, string> = {
    [betTypeMap.PickWinner]: t('Pick Winner'),
    [betTypeMap.StraightForecast]: t('Exact order'),
    [betTypeMap.ReverseForecast]: t('Any order'),
    [betTypeMap.CombinationTricast]: t('Any order'),
    [betTypeMap.Tricast]: t('Exact order')
  }

  return <span className={className}>{BetLabelMap[betType]}</span>
}
